import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useNavigate } from "react-router-dom";

const DropDown = ({
  dropNo,
  currentTab,
  handleContact,
  linkInfo,
  btnValue,
  toggleDropDown,
  contact,
}) => {
  const navigate = useNavigate();
  const Active = `
  .navbar .nav-tabs .nav-link.active::before {
      background:  #1e538f00;
    }
    // .navbar .nav-tabs .nav-link.active{
    //   color:${!contact ? "#1E538F" : "#090b19"}!important;
    // }
    .navbar .nav-tabs .nav-active::before {
      content: '';
      position: absolute;
      display: block;
      width: 75px;
      height: 3px;
       top: 72px;
       margin-left:12px;
      
      background:  #1E538F;
      bottom: 0;
    }
    .navbar .nav-tabs .nav-inactive::before {
      content: '';
      position: absolute;
      display: block;
      width: 75px;
      height: 3px;
       top: 72px;
       margin-left:12px;
      
      background:  #1e538f00;
      bottom: 0;
    }
    .navbar .nav-tabs .nav-active{
      color: #1e538f !important;
    }
 
    `;

  return (
    <>
      <style>{Active}</style>
      {dropNo === 4 ? (
        <li
          className={`nav-item  ${
            dropNo == currentTab ? "nav-active" : "nav-inactive"
          } `}
        >
          <a
            className="nav-link border-0 pinter-cursor"
            data-bs-toggle="tab"
            onClick={() =>
              toggleDropDown(dropNo, linkInfo?.drop_nav1_link, null)
            }
          >
            {" "}
            {linkInfo?.nav_name}{" "}
          </a>
        </li>
      ) : dropNo === 6 ? (
        <li
          className={`nav-item  ${
            dropNo == currentTab ? "nav-active" : "nav-inactive"
          } `}
        >
          <a
            onClick={() => handleContact(true, dropNo)}
            className="nav-link border-0  pinter-cursor"
            href={linkInfo?.drop_nav1_link}
          >
            {" "}
            {linkInfo?.nav_name}{" "}
          </a>
        </li>
      ) : (
        <li
          className={`nav-item  ${
            dropNo == currentTab ? "nav-active" : "nav-inactive"
          } `}
        >
          <a
            className={`nav-link border-0  ${dropNo === btnValue && "active"} `}
            onClick={() => toggleDropDown(dropNo, linkInfo?.nav_name, null)}
            href="#"
            id="navbarDropdown"
            role="button"
            data-bs-toggle="tab"
          >
            {linkInfo?.nav_name}
            <FontAwesomeIcon
              className=" ms-2"
              icon={btnValue === dropNo ? faChevronUp : faChevronDown}
            />
          </a>
          <ul
            className={`dropdown-menu  ${
              btnValue === dropNo ? "d-block" : "d-none"
            }`}
          >
            <li>
              <a
                className="dropdown-item"
                onClick={() =>
                  toggleDropDown(
                    dropNo,
                    linkInfo?.drop_nav1,
                    linkInfo?.drop_nav1_link
                  )
                }
                href={
                  linkInfo?.drop_nav1_link?.slice(0, 1) === "/"
                    ? linkInfo?.drop_nav1_link
                    : null
                }
              >
                {" "}
                {linkInfo?.drop_nav1}{" "}
              </a>
            </li>
            <li>
              <a
                className="dropdown-item"
                onClick={() =>
                  toggleDropDown(
                    dropNo,
                    linkInfo?.drop_nav2,
                    linkInfo?.drop_nav2_link
                  )
                }
                href={
                  linkInfo?.drop_nav2_link?.slice(0, 1) === "/"
                    ? linkInfo?.drop_nav2_link
                    : null
                }
              >
                {linkInfo?.drop_nav2}
              </a>
            </li>

            <li>
              <a
                className="dropdown-item"
                onClick={() =>
                  toggleDropDown(
                    dropNo,
                    linkInfo?.drop_nav3,
                    linkInfo?.drop_nav3_link
                  )
                }
                href={
                  linkInfo?.drop_nav3_link?.slice(0, 1) === "/"
                    ? linkInfo?.drop_nav3_link
                    : null
                }
              >
                {linkInfo?.drop_nav3}
              </a>
            </li>
            {linkInfo?.drop_nav4 && (
              <li>
                <a
                  target={
                    linkInfo?.drop_nav4_link?.slice(0, 1) === "/"
                      ?"_self"
                      :"_blank"
                  }
                  rel="noreferrer"
                  className="dropdown-item"
                  onClick={() =>
                    linkInfo?.drop_nav4_link?.slice(0, 1) === "/" &&
                    toggleDropDown(
                      dropNo,
                      linkInfo?.drop_nav4,
                      linkInfo?.drop_nav4_link
                    )
                  }
                  href={
                    linkInfo?.drop_nav4_link?.slice(0, 1) === "/"
                      ? linkInfo?.drop_nav4_link
                      : linkInfo?.drop_nav4_link
                  }
                >
                  {linkInfo?.drop_nav4}
                </a>
              </li>
            )}
            {linkInfo?.drop_nav5 && (
              <li>
                <a
                  className="dropdown-item"
                  onClick={() =>
                    toggleDropDown(
                      dropNo,
                      linkInfo?.drop_nav5,
                      linkInfo?.drop_nav5_link
                    )
                  }
                  href={
                    linkInfo?.drop_nav5_link?.slice(0, 1) === "/"
                      ? linkInfo?.drop_nav5_link
                      : null
                  }
                >
                  {linkInfo?.drop_nav5}
                </a>
              </li>
            )}
            {linkInfo?.drop_nav6 && (
              <li>
                <a
                  className="dropdown-item"
                  onClick={() =>
                    toggleDropDown(
                      dropNo,
                      linkInfo?.drop_nav6,
                      linkInfo?.drop_nav6_link
                    )
                  }
                  href={
                    linkInfo?.drop_nav6_link?.slice(0, 1) === "/"
                      ? linkInfo?.drop_nav6_link
                      : null
                  }
                >
                  {linkInfo?.drop_nav6}
                </a>
              </li>
            )}
            {linkInfo?.drop_nav7 && (
              <li>
                <a
                  className="dropdown-item"
                  onClick={() =>
                    toggleDropDown(
                      dropNo,
                      linkInfo?.drop_nav7,
                      linkInfo?.drop_nav7_link
                    )
                  }
                  href={
                    linkInfo?.drop_nav7_link?.slice(0, 1) === "/"
                      ? linkInfo?.drop_nav7_link
                      : null
                  }
                >
                  {linkInfo?.drop_nav7}
                </a>
              </li>
            )}
            {linkInfo?.drop_nav8 && (
              <li>
                <a
                  className="dropdown-item"
                  onClick={() =>
                    toggleDropDown(
                      dropNo,
                      linkInfo?.drop_nav8,
                      linkInfo?.drop_nav8_link
                    )
                  }
                  href={
                    linkInfo?.drop_nav8_link?.slice(0, 1) === "/"
                      ? linkInfo?.drop_nav8_link
                      : null
                  }
                >
                  {linkInfo?.drop_nav8}
                </a>
              </li>
            )}
          </ul>
        </li>
      )}
    </>
  );
};

export default DropDown;
